import fetch from "@/api/httpFetch.js";
const apiPrefix = "/openplat-user-server/v";
const undertaker_id = "sjrxtyjs";

function isUserLogined() {
  //有token，证明已登录
  return !!sessionStorage.getItem("Access-Token");
}
// 获取比赛关卡的信息状态
function getLevelList() {
  return fetch.get(`${apiPrefix}/getLevelList`);
}

/*                     新接口                      */

// 获取已报名队伍列表
/**
 * @desc 获取已报名队伍列表
 * @param undertaker_id 参加的比赛id
 *        page_size 分页大小
 *        page_num 分页页码
 */
function queryCompetTeam(data) {
  return fetch.post(`${apiPrefix}/undertake/queryCompetTeam`, {
    ...data,
    undertaker_id
  });
}
/**
 * @desc 个人信息补充
 * @param undertaker_id 参加的比赛id
 *        emp_name 名称
 *        emp_post 子公司/部门
 *        subordinate_company 归属公司
 */
function putCompetEmp(data) {
  return fetch.post(`${apiPrefix}/undertake/putCompetEmp`, {
    undertaker_id,
    ...data
  });
}

/**
 * @desc 创建队伍
 * @param undertaker_id 参加的比赛id
 *        team_name 队伍名称
 *        emp_name 名称
 *        emp_post 子公司/部门
 *        subordinate_company 归属公司
 */
function postCompetTeam(data) {
  return fetch.post(
    `${apiPrefix}/undertake/postCompetTeam`,
    {
      undertaker_id,
      ...data
    },
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 加入队伍
 * @param undertaker_id 参加的比赛id
 *        team_id 队伍id
 */
function addCompetTeam(team_id) {
  return fetch.post(
    `${apiPrefix}/undertake/addCompetTeam`,
    {
      undertaker_id,
      team_id
    },
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 归属公司下拉框
 * @param config_id competition_subordinate_company
 */
function competOption() {
  return fetch.get(
    `${apiPrefix}/compet/option?config_id=competition_subordinate_company`
  );
}

/**
 * @desc 获取队伍信息
 * @param undertaker_id 参加的比赛id
 */
function getEmpTeam() {
  return fetch.get(
    `${apiPrefix}/undertake/getEmpTeam?undertaker_id=${undertaker_id}`
  );
}

/**
 * @desc 获取报名信息
 * @param undertaker_id 参加的比赛id
 */
function getCompetEmp() {
  return fetch.get(
    `${apiPrefix}/undertake/getCompetEmp?undertaker_id=${undertaker_id}`
  );
}

/**
 * @desc 获取指定队伍信息
 * @param undertaker_id 参加的比赛id
 */
function getCompetTeam(team_id) {
  return fetch.get(
    `${apiPrefix}/undertake/getCompetTeam?undertaker_id=${undertaker_id}&team_id=${team_id}`
  );
}

/**
 * @desc 获取邀请地址
 * @param undertaker_id 参加的比赛id
 */
function inviteUrl() {
  return fetch.get(
    `${apiPrefix}/undertake/getEmpTeam/inviteUrl?undertaker_id=${undertaker_id}`,
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 更新队伍状态【完成组队、重新开启组队】
 * @param undertaker_id 参加的比赛id
 *        team_status 0-开启组队，1-完成组队
 */
function updateCompetTeamStatus(team_status) {
  return fetch.post(
    `${apiPrefix}/undertake/updateCompetTeamStatus`,
    {
      undertaker_id,
      team_status
    },
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 移除队员
 * @param undertaker_id 参加的比赛id
 *        del_emp_id 删除的用户id
 */
function deleteCompetTeamEmp(del_emp_id) {
  return fetch.post(
    `${apiPrefix}/undertake/deleteCompetTeamEmp`,
    {
      undertaker_id,
      del_emp_id
    },
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 解散队伍
 * @param undertaker_id 参加的比赛id
 */
function disbandCompetTeam() {
  return fetch.post(
    `${apiPrefix}/undertake/disbandCompetTeam`,
    {
      undertaker_id
    },
    {
      errorHandler: true
    }
  );
}

/**
 * @desc 排行榜
 */
function ranks() {
  return fetch.get(`${apiPrefix}/financial2022/examination/ranks`);
}

export default {
  queryCompetTeam,
  isUserLogined,
  getLevelList,
  putCompetEmp,
  postCompetTeam,
  addCompetTeam,
  competOption,
  getEmpTeam,
  getCompetEmp,
  getCompetTeam,
  inviteUrl,
  updateCompetTeamStatus,
  deleteCompetTeamEmp,
  disbandCompetTeam,
  ranks
};



// WEBPACK FOOTER //
// ./src/gtn/api/competition/financialIndex.js